export default __webpack_public_path__ + "static/media/HelveticaNeueBold.ba2f3586.woff2";